module.exports = __webpack_public_path__ + "img/red_056.788562f4.png";